import * as Yup from "yup";

export const bankDetailsValidationSchemaConsignado = Yup.object().shape({
  accountType: Yup.number()
    .required("Tipo de conta é obrigatório")
    .typeError("Tipo de conta deve ser um número")
    .min(1, "Tipo de conta inválido")
    .max(9, "Tipo de conta inválido"),

  bankCode: Yup.string()
    .required("Banco é obrigatório")
    .matches(/^\d{3}$/, "Código do banco deve ter exatamente 3 dígitos")
    .typeError("Código do banco deve conter apenas números"),

  agency: Yup.string()
    .required("Agência é obrigatória")
    .matches(/^\d{4}$/, "Agência deve ter exatamente 4 dígitos")
    .typeError("Agência deve conter apenas números"),

  agencyDigit: Yup.string()
    .required("Dígito da agência é obrigatório")
    .matches(/^\d{1}$|^$/, "Dígito da agência deve ter 1 dígito ou estar vazio")
    .max(1, "Dígito da agência deve ter no máximo 1 caractere"),

  account: Yup.string()
    .required("Número da conta é obrigatório")
    .matches(/^\d+$/, "Número da conta deve conter apenas números")
    .min(1, "Número da conta não pode ser vazio")
    .max(11, "Número da conta deve ter no máximo 11 dígitos"),

  accountDigit: Yup.string()
    .required("Dígito da conta é obrigatório")
    .matches(/^\d{1}$/, "Dígito da conta deve ter exatamente 1 dígito")
    .typeError("Dígito da conta deve ser um número"),
});